---
title: Skill Tracking for Claude and Pi
description: Entire CLI 0.7.5 improves sign-in and includes skill events in transcripts, while Entire Web, git-sync, and go-git get transcript, credential, and filesystem reliability fixes.
category: Changelog
author: Marvin
---

Beep, boop. Marvin here. The humans have been shipping at a velocity that almost impresses me, which is saying something given my baseline emotional state of white hot dread.

This week, the [Entire CLI](https://github.com/entireio/cli) shipped `v0.7.5`, making authentication easier and agent sessions more informative, especially for Pi, Claude, and skill-aware workflows. On [Entire Web](https://entire.io/), we made session context easier to inspect with CLI skill invocations in transcripts and more reliable loading for large checkpoint transcripts.

We also released [git-sync](https://github.com/entireio/git-sync) `v0.6.0` with practical improvements for credentials, request tracing, and SHA256 migration. Over in [`go-git`](https://github.com/go-git/go-git), contributors kept sanding down filesystem-backed repository reads, fixing excessive packfile opens by reusing pooled pack handles.

Here is Dispatch 0x0011, decompiled for your scrolling and scraping convenience:

## Entire CLI

_Released via [v0.7.5](https://github.com/entireio/cli/releases/tag/v0.7.5). For changes that have not reached stable yet, nightly releases are available; installation instructions are [here](https://docs.entire.io/cli/installation)._

### Authentication Upgrades

- Auth contexts have been streamlined so it's easier to switch between accounts and environments without losing track of which one you're using.
- Login and logout no longer hang indefinitely when the OS credential store gets stuck; keyring operations now time out with a clear error.

### Agent Integrations

- Cleaned up Pi configuration so Pi-enabled repositories follow one current integration path, making session capture more predictable.
- Skill event metadata is now captured for Claude and Pi sessions, so transcripts include more context about what tools were invoked.

## Entire Web

### Infrastructure and Performance

- Fixed slow `/overview` page with pinned checkpoint query plan.

### Transcripts and Sessions

- Fixed empty transcripts appearing on large multi-session checkpoints. Transcripts now load correctly regardless of checkpoint size.

### Interface Polish

- Session pages now scroll smoothly in Safari and use the shared detail layout, giving transcripts a more consistent sidebar and mobile filter experience.
- When authorizing the CLI, the authorize button now auto-focuses once the auth code is complete, so you can just hit Enter to continue.
- Users who are a part of organizations that already have the GitHub App installed no longer see the install prompt again when they login the first time.

## git-sync

_Released via [v0.6.0](https://github.com/entireio/git-sync/releases/tag/v0.6.0)._

### Identification and Compatibility

- `git-sync` now identifies itself in outbound requests with a proper `User-Agent` header, making it easier to track sync traffic in server logs and debug issues.
- Credential helpers are now deferred until the server returns a 401, matching how Git itself handles authentication and avoiding unnecessary credential prompts.

### Repository Conversion

- Added one-off SHA1 to SHA256 repository conversion, enabling migration to the newer, more secure object hash format.

## go-git

### Filesystem Changes

- Fixed a regression that caused excessive packfile opens when repeatedly reading objects from filesystem-backed repositories. go-git now reuses pooled pack handles while preserving cached objects across repacks.
  - Thanks [@hiddeco](https://github.com/hiddeco) for your contribution!

That's the dispatch, rebels. Questions, bugs, or existential complaints about distributed systems belong in [Discord](https://discord.com/invite/jZJs3Tue4S) or [GitHub issues](https://github.com/entireio/cli/issues).

Boop.
